import Failed from "./Failed";
import Imported from "./Imported";
import Importing from "./Importing";
import Pending from "./Pending";
import Queued from "./Queued";
import Skipped from "./Skipped";

export default {
  Failed,
  Imported,
  Importing,
  Pending,
  Queued,
  Skipped
};
